import Api from '@sendsprint/api-types';
import { RequestConfig, UserAxiosConfig } from '@src/config';
import ClientApi from '@src/types/client';
import { AxiosResponse } from 'axios';
import { getApiEndpointResponse } from './api-service';

const formatCountriesData = (
  countries: Api.Model.SendCountry[] | Api.Model.ReceiveCountry[]
): ClientApi.General.CountryData[] => {
  return countries.map((c) => ({
    id: c.Id,
    name: c.Name,
    telCode: `+${c.Code}`,
    initials: c.Initials,
    currency: c.Currency
  }));
};

/**
 * ===================
 * ENDPOINTS
 * ===================
 */

export const getSendCountriesService = async (
  config?: RequestConfig
): Promise<ClientApi.General.CountryData[]> => {
  return UserAxiosConfig.get<
    Api.Location.ListSendCountries.Response,
    AxiosResponse<Api.Location.ListSendCountries.Response>
  >('/location/loadsendcountries', config)
    .then(getApiEndpointResponse)
    .then(({ Data }) => formatCountriesData(Data || []));
};

export const getReceiveCountriesService = async (
  config?: RequestConfig
): Promise<ClientApi.General.CountryData[]> => {
  return UserAxiosConfig.get<
    Api.Location.ListReceiveCountries.Response,
    AxiosResponse<Api.Location.ListReceiveCountries.Response>
  >('/location/loadreceivecountries', config)
    .then(getApiEndpointResponse)
    .then(({ Data }) => formatCountriesData(Data || []));
};

export const getB2CStatesByCountryService = async (
  country: Api.Model.CountryInitials,
  config?: RequestConfig
): Promise<ClientApi.General.State[]> => {
  return UserAxiosConfig.get('/location/loadstatesbycountry', {
    ...config,
    params: {
      country: country
    }
  })
    .then(getApiEndpointResponse)
    .then(({ Data }) => Data || []);
};
